<template>
  <div>
    <preamble v-bind="preamble" />
    <section class="main">
        <div class="container">
            <div class="columns">
                <div class="column is-8 is-offset-2">
                  <div class="columns">
                      <div class="column is-12">
                        <div class="your-story">
                          <div class="columns">
                            <div class="column is-8">
                              <h2>Would you like to share your story?</h2>
                            </div>
                            <div class="column is-4">
                              <a v-if="!showForm" @click="handleGotoForm" class="submit-button button is-black is-fullwidth is-medium">Yes!</a>
                            </div>
                        </div>
                        </div>
                      </div>
                    </div>
                    <div class="columns legacy">
                        <div class="column is-12">
                            <div class="" v-if="contact.longDescription" v-html="contact.longDescription">
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </section>
  </div>
</template>
<script>
    import Preamble from '@/components/Preamble.vue'
    import sharedMethodsMixin from '@/mixins/sharedMethodsMixin'
    import { resources, API } from '@/utils/constants'

    export default {
        name: "Contact",
        mixins: [sharedMethodsMixin],
        components: {
                Preamble    
                },
        data() {
            return {
              contact: {},
              contactImages: [],
              preamble: {
                title: 'Share Your Story',
                subTitle: '...',
                description: '',
                watchVideo: '',

              },
            }
        },
        created() {
          
          this.read(`${resources.contact}`)
                    .then(response => {
                    this.contact = response.data[0]

                    this.preamble = {
                            title: this.contact.title, 
                            subTitle: this.contact.tagLine,
                            secondaryTitle: this.contact.subTitle,
                            description: this.contact.shortDescription,
                        }
                })
        
        },
        mounted() {
            
        },
        methods: {
          handleGotoForm() {
            window.open(this.contact.videoLink, '_blank');
          },

          handlePop() {
            this.popContent = {...this.currentLine, triggered: true}
          },

          closePop() {
            this.popContent.triggered = false;
          }
        },
        computed: {
             
        },
    }
</script>

<style>
</style>
